import { MESSAGES_REQUEST } from "./constants";

export const fetchMessages = (application?: "pw-lis" | "viewer") => {
  return {
    type: MESSAGES_REQUEST,
    payload: application,
  };
};
